export default "Here are some possible reasons:\n\n- You’re under 21 years of age.\n- There was an issue with your credit.\n";